var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Legend"},[_c('LegendPlanmode',{staticClass:"mt-3",attrs:{"label":"Laadlocaties"}}),_c('LegendPrognose',{staticClass:"mt-5"}),_c('LegendSegment',{staticClass:"mt-5",attrs:{"label":"Context informatie"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }